import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_16wdwaco: FaireBrandEntity = {
  token: "b_16wdwaco",
  type: "brand",
  name: "Just Bee",
  avatarUrl:
    "https://cdn.faire.com/fastly/de6e265bd4456cb36c897033f12b54fe217da814cd7c2d4847cf63fd99e40121.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/97a7e0663be70559c6ff3482ed51620f186b39a474bd6e0f63f6f2869532895a.png",
  logoUrl:
    "https://cdn.faire.com/fastly/de6e265bd4456cb36c897033f12b54fe217da814cd7c2d4847cf63fd99e40121.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/97a7e0663be70559c6ff3482ed51620f186b39a474bd6e0f63f6f2869532895a.png",
  location: "Peoria, IL, USA",
  minimumOrderDollars: 0,
  rating: 5,
  reviewCount: 563,
  isTopShop: true,
  isInsider: true,
  description:
    "Hi! We are Ben and Sarah Mitzelfelt, the husband and wife/founders of Just Bee. We founded Just Bee in 2011 a year after Ben, following in the footsteps of his great-grandfather, started bee-keeping. After his first season, Sarah used our beeswax and other organic ingredients to make our first product – Just Bee Sweet. We work in harmony with nature to create products you can feel good using. Experimenting and perfecting the formulations, Sarah found a unique blend that was thicker and more protective than other lip balms on the market. After sharing our creations with our family and friends, we started selling our lip balms in small, local businesses. The brand has steadily grown since then. \n\nThe Just Bee line now includes our signature lip products, as well as other bee-infused beauty products. Just Bee products are designed to deliver outstanding results while utilizing the highest quality of natural ingredients. They are high performance, clean, cruelty-free and bee-friendly. From the inception of Just Bee, we have dedicated ourselves to producing 100% naturally high-quality products that nourish and protect your skin. All Just Bee products are thoughtfully crafted in small batches to ensure you receive only the best nature has to offer.\n\n",
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:50:43.448Z",
    importedBy: "entity-db-cli",
  },
};
